module.exports = __webpack_public_path__ + "static/media/IconoGranPregunta.275aa416.svg";